import { render, staticRenderFns } from "./ticketsView.vue?vue&type=template&id=01eec046&scoped=true&"
import script from "./ticketsView.vue?vue&type=script&lang=js&"
export * from "./ticketsView.vue?vue&type=script&lang=js&"
import style0 from "./ticketsView.vue?vue&type=style&index=0&id=01eec046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eec046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01eec046')) {
      api.createRecord('01eec046', component.options)
    } else {
      api.reload('01eec046', component.options)
    }
    module.hot.accept("./ticketsView.vue?vue&type=template&id=01eec046&scoped=true&", function () {
      api.rerender('01eec046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/ticketsView.vue"
export default component.exports